export default "__VITE_ASSET__BAYdj7hz__"